module.exports = __webpack_public_path__ + "static/media/xuqiudiaoyanliucheng.99b6c076.png";